import { DISPLAY_ERROR_CODES } from './constants';
import { ZodError } from './types';

export const filterFieldErrors = (errors: ZodError[]): { message: string }[] =>
  errors
    .filter((e) => DISPLAY_ERROR_CODES.includes((e as { code?: string }).code ?? ''))
    .map((e) => ({
      message: typeof e === 'string' ? e : String((e as { message?: string }).message ?? e),
    }));
